@for (indicator of outlookIndicatorsSummed; track indicator) {
  <app-outlook-indicator [size]="size" [outlookIndicator]="indicator"/>
}
